import * as selectors from "./clientContext.selectors";
import slice from "./clientContext.slice";
export const {
  name,
  actions: { updateClientConfig },
  reducer
} = slice;

export const { selectClientConfig } = selectors;
